import React from "react";
import { useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { msalInstance } from "../../utilities/auth/msalConfig";
import { Dropdown, Menu } from "antd";
import questionmarkoutlined from "../../assets/images/questionmarkoutlined.png";
import avatarVector from "../../assets/images/avatarVector.png";
import ellipse150 from "../../assets/images/ellipse150.png";
import "./style.scss";

const menu = (props) => (
  <Menu>
    <Menu.Item key="0">
      <a rel="noopener noreferrer" onClick={props.handleLogout}>
        Logout
      </a>
    </Menu.Item>
  </Menu>
);

function Index(props) {
  const { app_role_home } = useSelector((state) => state.hometab);
  const handleLogout = async () => {
    sessionStorage.clear();
    const accounts = msalInstance.getAllAccounts();

    if (accounts.length === 0) {
      msalInstance.logoutRedirect();
    } else {
      let homeAccountId = accounts[0].homeAccountId;
      const currentAccount = msalInstance.getAccountByHomeId(homeAccountId);

      await msalInstance.logoutRedirect({
        account: currentAccount,
      });
    }
  };

  return (
    <header className="site-header">
      <div className="header-left">
        <div className="site-logo">
          <img src="/assets/images/mars-logo.svg" width="80" alt="Mars" />
        </div>
        <span className="header-divider"></span>
        <div className="header-text">Customer Market Self Serve</div>
      </div>
      <div className="header-right">
        <div>
          {app_role_home === "Tool.Admin" ? (
            <ul className="admin-menu">
              <li
                className={
                  "menu-item" + " " + (props.tab === "0" ? "active" : "")
                }
                onClick={() => {
                  props.history.push("/home");
                }}
              >
                Home
              </li>

              <li
                className={
                  "menu-item" + " " + (props.tab === "2" ? "active" : "")
                }
                onClick={() => {
                  props.history.push("/nielsen");
                }}
              >
                Nielsen Data
              </li>

              <li
                className={
                  "menu-item" + " " + (props.tab === "4" ? "active" : "")
                }
                onClick={() => {
                  props.history.push("/epos");
                }}
              >
                EPOS Data
              </li>

              <li
                className={
                  "menu-item" + " " + (props.tab === "12" ? "active" : "")
                }
                onClick={() => {
                  props.history.push("/user-management");
                }}
              >
                User Management
              </li>
             
              <li
                className={
                  "menu-item" + " " + (props.tab === "14" ? "active" : "")
                }
                onClick={() => {
                  props.history.push("/user-statistics");
                }}
              >
                User statistics
              </li>

            </ul>
          ) : app_role_home === "Read.AllDatasets" ? (
            <ul className="menu">
              <li
                className={
                  "menu-item" + " " + (props.tab === "0" ? "active" : "")
                }
                onClick={() => {
                  props.history.push("/home");
                }}
              >
                Home
              </li>

              <li
                className={
                  "menu-item" + " " + (props.tab === "2" ? "active" : "")
                }
                onClick={() => {
                  props.history.push("/nielsen");
                }}
              >
                Nielsen Data
              </li>

              <li
                className={
                  "menu-item" + " " + (props.tab === "4" ? "active" : "")
                }
                onClick={() => {
                  props.history.push("/epos");
                }}
              >
                EPOS Data
              </li>
            </ul>
          ) : app_role_home === "Read.Nielsen" ? (
            <ul className="menu">
              <li
                className={
                  "menu-item" + " " + (props.tab === "0" ? "active" : "")
                }
                onClick={() => {
                  props.history.push("/home");
                }}
              >
                Home
              </li>

              <li
                className={
                  "menu-item" + " " + (props.tab === "2" ? "active" : "")
                }
                onClick={() => {
                  props.history.push("/nielsen");
                }}
              >
                Nielsen Data
              </li>
            </ul>
          ) : app_role_home === "Read.Epos" ? (
            <ul className="menu">
              <li
                className={
                  "menu-item" + " " + (props.tab === "0" ? "active" : "")
                }
                onClick={() => {
                  props.history.push("/home");
                }}
              >
                Home
              </li>

              <li
                className={
                  "menu-item" + " " + (props.tab === "4" ? "active" : "")
                }
                onClick={() => {
                  props.history.push("/epos");
                }}
              >
                EPOS Data
              </li>
            </ul>
          ) : (
            ""
          )}
        </div>
        <span
          className="questionmark-outlined"
          onClick={() => window.open(process.env.REACT_APP_USER_GUIDE_LINK)}
        >
          <img src={questionmarkoutlined} height="25" width="25" />
        </span>
        <span className="ellipse150-vector">
          <img src={ellipse150} height="36" width="36" />
        </span>
        <div>
          <Dropdown
            overlay={() => menu({ ...props, handleLogout })}
            placement="bottomRight"
          >
            <a
              className="ant-dropdown-link"
              style={{ display: "inline-block" }}
              onClick={(e) => e.preventDefault()}
            >
              <span className="avatar-vector">
                <img src={avatarVector} height="16" width="16" />
              </span>
            </a>
          </Dropdown>
        </div>
      </div>
    </header>
  );
}

export default withRouter(Index);
